import { createStorageSlice } from './slice';

export const RECEIPT_STORAGE_DOMAIN = 'qbp-receipts';

export const receiptStorageSlice = createStorageSlice(RECEIPT_STORAGE_DOMAIN);
